'use client';

import { useLocalStorage } from '@/hooks/useLocalStorage';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

// @ts-ignore
import timezoneLookup from 'tz-lookup';

interface ConditionUsesVPNProps extends PropsWithChildren {
  likely?: string;
  unlikely?: string;
}

export const ConditionUsesVPN: FC<ConditionUsesVPNProps> = ({
  likely,
  unlikely,
  children,
}) => {
  const { dataBlocks } = useTruth();
  const { ip, timezone } = dataBlocks;
  const { DataPopup } = useDataPopup();

  const [localStorage] = useLocalStorage('privacyArticle', {});

  const [handle, setHandle] = useState<React.ReactNode>(children);

  useEffect(() => {
    const { lastKnownLatLong = [0, 0] } = localStorage;

    if (lastKnownLatLong[0] !== 0 && lastKnownLatLong[1] !== 0) {
      const timezone = timezoneLookup(lastKnownLatLong[0], lastKnownLatLong[1]);

      const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      if (timezone === localTimezone) {
        setHandle(unlikely);
      } else {
        setHandle(likely);
      }
    } else {
      setHandle(children);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed on the geolocation fetch, which also writes lastKnownLatLong
  }, [ip?.value, timezone?.value]);

  return (
    <DataPopup
      handle={handle}
      subheading={messages['condition.usesVPN.description']}
      condition={{
        title: messages['condition.usesVPN'],
        options: [
          {
            title: messages['condition.usesVPN.likely'],
            value: likely,
          },
          {
            title: messages['condition.usesVPN.unlikely'],
            value: unlikely,
          },
          {
            title: messages['condition.usesVPN.unknown'],
            value: children?.toString() || '',
          },
        ],
      }}
      dataBlocks={{ ip, timezone }}
    />
  );
};
